import { useCallback } from "react";
import { observer } from "mobx-react";
import { useRootStore } from "@/state/RootStore";
import { RecoverableErrorBanner } from "./RecoverableErrorBanner";

/**
 * Shown when we could not confirm the user's entitlements.
 *
 * Without it, a subscriber whose purchase-state check fails twice is silently rendered
 * the FREE experience — locked study content, upgrade prompts for something they already
 * bought — with no explanation and no way to retry. (There is no restore-purchases UI on
 * web: `showRestoreButton` is set in the store but no component reads it.)
 */
export const PurchaseStateErrorBanner = observer(() => {
  const store = useRootStore();

  const handleRetry = useCallback(
    () => store.mainAppStore.retryPurchaseState(),
    [store],
  );
  const stillFailing = useCallback(
    () => store.mainAppStore.purchaseStateError,
    [store],
  );

  if (!store.mainAppStore.purchaseStateError) return null;

  return (
    <RecoverableErrorBanner
      messageKey="errors.purchase_state_unconfirmed"
      onRetry={handleRetry}
      stillFailing={stillFailing}
    />
  );
});

export default PurchaseStateErrorBanner;
